<script lang="ts" setup>
import CarouselComponent from "@/components/carousel/CarouselComponent.vue";
import { onMounted, ref } from "vue";
import ModalComponent from "@/components/ModalComponent.vue";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { useUserStore } from "@/stores/userStore";
import EmptyModal from "@/components/modals/EmptyModal.vue";

const showPaidModal = ref(false);
const showBlockScreenModal = ref(false);

onMounted(async () => {
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");
  if (!sessionId) {
    return;
  }
  try {
    showBlockScreenModal.value = true;
    const userStore = useUserStore();
    await userStore.checkStripeSuccess(sessionId);
    showPaidModal.value = true;
  } catch (error) {
    console.log(error);
  } finally {
    showBlockScreenModal.value = false;
  }
});
</script>

<template>
  <CarouselComponent />
  <ModalComponent :show="showPaidModal" @close="showPaidModal = false">
    <template #header>
      <p class="text-2xl font-semibold text-black">Поздравляем</p>
    </template>
    <template #content>
      <div class="w-full flex flex-col gap-4">
        <p class="text-brown text-lg font-medium">
          Ваша подписка успешно оформлена !
        </p>
        <GradientButton
          class="min-h-14"
          bg-color="bg-brown-gradient"
          hover-bg-color="bg-orange-gradient"
          text="Ок"
          @click="showPaidModal = false"
        />
      </div>
    </template>
  </ModalComponent>
  <EmptyModal :show="showBlockScreenModal" />
</template>
